/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { handleLogout } from '../../Services/crypto';
import { continuarSesion } from '../../API/IT/Users/UserRequests';
import { AuthContext } from '../../Context/AuthContext/AuthContext';


// Componentes PrimeReact

const ModalDieSession = () => {

    const { userAuth } = useContext(AuthContext);

    const maxTiempoActivo = 20; // minutos
    const tiempoRenovacion = 15; //Minutos

    const [modalDieSession, setModalDieSession] = useState(false)


    const hideDialog = () => {
        setModalDieSession(false);
    }

    const continuar = async (reset) => {
        continuarSesion();
        if (reset) {
            document.getElementById('root').click()
            ResetTimer()
        }
        hideDialog();
    }


    const ResetTimer = () => {
        // if(userAuth.AccesosWeb?.split(',')?.includes('17')){
        //     localStorage.setItem(process.env.REACT_APP_StorageTokenDieTiempo, new Date((new Date()).getTime() + 1000 * 60 * 60 * 24 * 99999));
        // }else{
            localStorage.setItem(process.env.REACT_APP_StorageTokenDieTiempo, new Date((new Date()).getTime() + maxTiempoActivo * 60 * 1000));
        // }
    }


    useEffect(() => {
        
        ResetTimer();


        document.querySelector('body').addEventListener('click', ResetTimer);
        document.querySelector('body').addEventListener('mousemove', ResetTimer);
        setInterval(() => {
            const tiempoActual = new Date();
            const tiempoDieSesion = new Date(localStorage.getItem(process.env.REACT_APP_StorageTokenDieTiempo));
            const tiempoCreoToken = new Date(localStorage.getItem(process.env.REACT_APP_StorageTokenTiempo));

            
            // console.log( (tiempoActual - tiempoCreoToken >= (maxTiempoActivo - tiempoRenovacion) * 60 * 1000) );
            // console.log('Tiempo restante de inactividad',(tiempoDieSesion - tiempoActual) / 1000, tiempoRenovacion * 1000)
            // console.log('Tiempo en que vencera el token',(tiempoActual - tiempoCreoToken) / 1000,  (maxTiempoActivo - tiempoRenovacion) * 60 * 1000)
            if (tiempoDieSesion - tiempoActual <= 1 * 60 * 1000) {
                if (tiempoDieSesion - tiempoActual <= 0) {
                    handleLogout()
                } else {
                    setModalDieSession(true);
                }
            } else {
                hideDialog();
                if ((tiempoActual - tiempoCreoToken >= (maxTiempoActivo - tiempoRenovacion) * 60 * 1000) && (tiempoDieSesion - tiempoActual > tiempoRenovacion * 60 * 1000)) {
                    continuar(false);
                    console.log('token por vencer')
                }
            }
        }, 5 * 1000);

    }, [])



    const footer = (
        <div>
            <Button className='p-button-outlined' label="No" icon="pi pi-times" onClick={handleLogout} />
            <Button className='' label="Si" icon="pi pi-check" onClick={e => continuar(true)} />
        </div>
    );

    return (
        <Dialog className='modal__contenedor' header="Aviso de sesión" footer={footer} visible={modalDieSession} position="top" modal style={{ width: '50vw' }} onHide={() => hideDialog('displayPosition')}
            draggable={false} resizable={false} closable={false}>
            <strong className="m-0">No ha habido actividad reciente.</strong>
            <p className="m-0">Su sesión esta a punto de caducar. ¿Quiere extender su sesion actual?</p>
        </Dialog>
    )
}

export default ModalDieSession